module.exports = __webpack_public_path__ + "img/slide-5.f2f80e12.png";